import { render, staticRenderFns } from "./CurrentActivity.vue?vue&type=template&id=5a112a41&scoped=true&"
import script from "./CurrentActivity.vue?vue&type=script&lang=js&"
export * from "./CurrentActivity.vue?vue&type=script&lang=js&"
import style0 from "./CurrentActivity.vue?vue&type=style&index=0&id=5a112a41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a112a41",
  null
  
)

export default component.exports